module.exports = __webpack_public_path__ + "static/media/back-1200.3b2c819d.jpg";